import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { theme } from '../themes';

export type HeaderItem = {
  href: string;
  icon: any;
  description: string;
  color: string;
  external?: boolean;
};

const visitorHeaderItems: HeaderItem[] = [
  {
    href: `${import.meta.env.REACT_APP_INTERNAL_PAGES_URL}/instructiuni-extern` ?? '',
    icon: PeopleAltIcon,
    description: 'Ghid utilizare',
    color: theme.palette.common.white,
    external: true
  }
]

const clientBenefitsHeaderItems: HeaderItem[] = [
  {
    href: '/indemnizatii-primarie/beneficiaries-list',
    icon: PeopleAltIcon,
    description: 'Beneficiari',
    color: theme.palette.common.white
  },
  {
    href: `${import.meta.env.REACT_APP_INTERNAL_PAGES_URL}/instructiuni` ?? '',
    icon: PeopleAltIcon,
    description: 'Ghid utilizare platforma',
    color: theme.palette.common.white,
    external: true
  }
];

const adminBenefitsHeaderItems: HeaderItem[] = [
  {
    href: '/admin-indemnizatii-primarie/user-list',
    icon: PeopleAltIcon,
    description: 'Utilizatori primarie',
    color: theme.palette.common.white
  },
  // {
  //   href: '/admin-indemnizatii-primarie/generare-borderou',
  //   icon: PeopleAltIcon,
  //   description: 'Generare borderou',
  //   color: theme.palette.common.white
  // },
  {
    href: '/admin-indemnizatii-primarie/user-beneficiaries-list',
    icon: PeopleAltIcon,
    description: 'Beneficiari primarie',
    color: theme.palette.common.white
  },
  {
    href: '/admin-indemnizatii-primarie/raport-incarcare-primarii',
    icon: PeopleAltIcon,
    description: 'Raport incarcare primarii',
    color: theme.palette.common.white
  }
  // ,
  // {
  //   href: `${import.meta.env.REACT_APP_PAGES_URL}/instructiuni` ?? '',
  //   icon: PeopleAltIcon,
  //   description: 'Ghid utilizare platforma',
  //   color: theme.palette.common.white,
  //   external: true
  // }
];

export { visitorHeaderItems, clientBenefitsHeaderItems, adminBenefitsHeaderItems };
